<template>
  <div class="view-product-index">
    <page-header
      title="Meus produtos"
      subtitle="Visualização de seus produtos"
    />
    <page-container>
      <b-tabs content-class="my-6" v-model="tab" @input="changeTab">
        <b-tab title="Sou produtor (a)">
          <producer-products />
        </b-tab>
        <b-tab title="Sou coprodutor (a)">
          <coproducer-products />
        </b-tab>
      </b-tabs>
    </page-container>
  </div>
</template>

<script>
import CoproducerProducts from "@/components/product/index/CoproducerProducts.vue";
import ProducerProducts from "@/components/product/index/ProducerProducts.vue";

export default {
  components: { ProducerProducts, CoproducerProducts },
  data() {
    const productsView = localStorage.getItem("productsView");
    return {
      tab: productsView === "coproducer" ? 1 : 0
    };
  },
  methods: {
    changeTab(v) {
      const value = v === 0 ? "producer" : "coproducer";
      localStorage.setItem("productsView", value);
    }
  }
};
</script>
